import { render, staticRenderFns } from "./Share_Option.vue?vue&type=template&id=6d88321d&scoped=true&"
import script from "./Share_Option.vue?vue&type=script&lang=js&"
export * from "./Share_Option.vue?vue&type=script&lang=js&"
import style0 from "./Share_Option.vue?vue&type=style&index=0&id=6d88321d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88321d",
  null
  
)

export default component.exports